import React from 'react';
import { getCurrencySymbol } from './string';
import messages from '../text/messages';
import { FormattedMessage } from 'react-intl';

export const displayValue = value => (value && typeof value === 'number' ? value.toFixed(2) : '0.00');

export function renderRate(currency, payType, rate, contractValue) {
    const currencySymbol = getCurrencySymbol(currency);
    const perHour = payType === 'h' ? '/hour' : '';
    return `${currencySymbol}${displayValue(rateValue(payType, rate, contractValue))}${perHour}`;
}

export function renderProjectRate(payType, project, hideName) {
    const { name, job_project } = project;
    const { rate_currency, rate, project_value } = job_project;
    const currencySymbol = getCurrencySymbol(rate_currency);
    const perHour = payType === 'h' ? '/hour' : '';
    const rateRes = `${currencySymbol}${displayValue(rateValue(payType, rate, project_value))}${perHour}`;
    return hideName ? rateRes : `${name}: ${rateRes}`;
}

export function getRateLabelAndValue(currency, payType, rate, contractValue) {
    const result = {
        label: <FormattedMessage {...getTypeLabel(payType)} />,
        value: renderRate(currency, payType, rate, contractValue)
    };
    return result;
}

export function renderProjectsValue(job, projects = [], hideName = false) {
    const proj = projects.length ? projects[0] : { job_project: {} };
    const { rate, currency, contract_value, pay_type } = job;

    const { job_project } = proj;

    const isSameRate =
        projects.length < 2 ||
        !projects.some(p => {
            return p.id !== proj.id && (pay_type === 'h' ? p.job_project.rate !== job_project.rate : p.job_project.project_value !== job_project.project_value);
        });

    return isSameRate
        ? renderRate(job_project.rate_currency || currency, pay_type, job_project.rate || rate, job_project.project_value || contract_value)
        : projects.map(project => <div>{renderProjectRate(pay_type, project, hideName)}</div>);
}

export function getProjectsRateLabelAndValue(job, projects) {
    return {
        label: <FormattedMessage {...getTypeLabel(job.pay_type)} />,
        value: renderProjectsValue(job, projects)
    };
}

function rateValue(payType, rate, contractValue) {
    switch (payType) {
        case 'h':
            return rate;
        case 's':
            return contractValue;
        default:
            return 0;
    }
}

function getTypeLabel(payType) {
    switch (payType) {
        case 'h':
            return messages.payRate;
        case 's':
            return messages.contractValue;
        default:
            return messages.payRate;
    }
}

export function getTypeMessage(payType) {
    switch (payType) {
        case 'h':
            return messages.hourly;
        case 's':
            return messages.perProject;
        default:
            return messages.emptyMessage;
    }
}



// WEBPACK FOOTER //
// ./src/utilities/rate.jsx